import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_ABORT_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useAbortCampaign = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const [abortCampaign, res] = esApi.endpoints.abortCampaign.useMutation()

  const abort = useCallback(
    async (campaignId: number) => {
      try {
        await abortCampaign({
          orgId: String(orgId),
          campaignId: String(campaignId),
        }).unwrap()

        dispatch(
          createNotification({
            'abort-campaign': {
              type: 'success',
              message: 'The campaign has been stopped.',
            },
          }),
        )

        return { id: Number(campaignId), aborted: true }
      } catch (error) {
        dispatch(
          createNotification({
            'abort-campaign': {
              type: 'error',
              message: getErrorMessage(error, ERROR_ABORT_CAMPAIGN_SERVER),
            },
          }),
        )
        return undefined
      }
    },
    [abortCampaign, dispatch, orgId],
  )

  return [abort, res] as const
}
